(() => {
  'use strict';

  // Noms français et aperçus sRGB indicatifs issus du jeu structuré RAL Classic
  // multilingue lunohodov/ral_classic.csv, complété avec les trois teintes
  // ajoutées à la collection officielle de 216 couleurs.
  /*__RAL_DATA_START__*/
  const RAL_COLOURS = [{"code":"1000","name":"Beige vert","hex":"#BEBD7F"},{"code":"1001","name":"Beige","hex":"#C2B078"},{"code":"1002","name":"Jaune sable","hex":"#C6A664"},{"code":"1003","name":"Jaune de sécurité","hex":"#E5BE01"},{"code":"1004","name":"Jaune or","hex":"#CDA434"},{"code":"1005","name":"Jaune miel","hex":"#A98307"},{"code":"1006","name":"Jaune maïs","hex":"#E4A010"},{"code":"1007","name":"Jaune narcisse","hex":"#DC9D00"},{"code":"1011","name":"Beige brun","hex":"#8A6642"},{"code":"1012","name":"Jaune citron","hex":"#C7B446"},{"code":"1013","name":"Blanc perlé","hex":"#EAE6CA"},{"code":"1014","name":"Ivoire","hex":"#E1CC4F"},{"code":"1015","name":"Ivoire clair","hex":"#E6D690"},{"code":"1016","name":"Jaune soufre","hex":"#EDFF21"},{"code":"1017","name":"Jaune safran","hex":"#F5D033"},{"code":"1018","name":"Jaune zinc","hex":"#F8F32B"},{"code":"1019","name":"Beige gris","hex":"#9E9764"},{"code":"1020","name":"Jaune olive","hex":"#999950"},{"code":"1021","name":"Jaune colza","hex":"#F3DA0B"},{"code":"1023","name":"Jaune signalisation","hex":"#FAD201"},{"code":"1024","name":"Jaune ocre","hex":"#AEA04B"},{"code":"1026","name":"Jaune brillant","hex":"#FFFF00"},{"code":"1027","name":"Jaune curry","hex":"#9D9101"},{"code":"1028","name":"Jaune melon","hex":"#F4A900"},{"code":"1032","name":"Jaune genêt","hex":"#D6AE01"},{"code":"1033","name":"Jaune dahlia","hex":"#F3A505"},{"code":"1034","name":"Jaune pastel","hex":"#EFA94A"},{"code":"1035","name":"Beige nacré","hex":"#6A5D4D"},{"code":"1036","name":"Or nacré","hex":"#705335"},{"code":"1037","name":"Jaune soleil","hex":"#F39F18"},{"code":"2000","name":"Orangé jaune","hex":"#ED760E"},{"code":"2001","name":"Orangé rouge","hex":"#C93C20"},{"code":"2002","name":"Orangé sang","hex":"#CB2821"},{"code":"2003","name":"Orangé pastel","hex":"#FF7514"},{"code":"2004","name":"Orangé pur","hex":"#F44611"},{"code":"2005","name":"Orangé brillant","hex":"#FF2301"},{"code":"2007","name":"Orangé clair brillant","hex":"#FFA420"},{"code":"2008","name":"Orangé rouge clair","hex":"#F75E25"},{"code":"2009","name":"Orangé signalisation","hex":"#F54021"},{"code":"2010","name":"Orangé de sécurité","hex":"#D84B20"},{"code":"2011","name":"Orangé foncé","hex":"#EC7C26"},{"code":"2012","name":"Orangé saumon","hex":"#E55137"},{"code":"2013","name":"Orangé nacré","hex":"#C35831"},{"code":"2017","name":"Orangé RAL","hex":"#FC5500"},{"code":"3000","name":"Rouge feu","hex":"#AF2B1E"},{"code":"3001","name":"Rouge de sécurité","hex":"#A52019"},{"code":"3002","name":"Rouge carmin","hex":"#A2231D"},{"code":"3003","name":"Rouge rubis","hex":"#9B111E"},{"code":"3004","name":"Rouge pourpre","hex":"#75151E"},{"code":"3005","name":"Rouge vin","hex":"#5E2129"},{"code":"3007","name":"Rouge noir","hex":"#412227"},{"code":"3009","name":"Rouge oxyde","hex":"#642424"},{"code":"3011","name":"Rouge brun","hex":"#781F19"},{"code":"3012","name":"Rouge beige","hex":"#C1876B"},{"code":"3013","name":"Rouge tomate","hex":"#A12312"},{"code":"3014","name":"Vieux rose","hex":"#D36E70"},{"code":"3015","name":"Rose clair","hex":"#EA899A"},{"code":"3016","name":"Rouge corail","hex":"#B32821"},{"code":"3017","name":"Rosé","hex":"#E63244"},{"code":"3018","name":"Rouge fraise","hex":"#D53032"},{"code":"3020","name":"Rouge signalisation","hex":"#CC0605"},{"code":"3022","name":"Rouge saumon","hex":"#D95030"},{"code":"3024","name":"Rouge brillant","hex":"#F80000"},{"code":"3026","name":"Rouge clair brillant","hex":"#FE0000"},{"code":"3027","name":"Rouge framboise","hex":"#C51D34"},{"code":"3028","name":"Rouge pur","hex":"#CB3234"},{"code":"3031","name":"Rouge oriental","hex":"#B32428"},{"code":"3032","name":"Rouge rubis nacré","hex":"#721422"},{"code":"3033","name":"Rose nacré","hex":"#B44C43"},{"code":"4001","name":"Lilas rouge","hex":"#6D3F5B"},{"code":"4002","name":"Violet rouge","hex":"#922B3E"},{"code":"4003","name":"Violet bruyère","hex":"#DE4C8A"},{"code":"4004","name":"Violet bordeaux","hex":"#641C34"},{"code":"4005","name":"Lilas bleu","hex":"#6C4675"},{"code":"4006","name":"Pourpre signalisation","hex":"#A03472"},{"code":"4007","name":"Violet pourpre","hex":"#4A192C"},{"code":"4008","name":"Violet de sécurité","hex":"#924E7D"},{"code":"4009","name":"Violet pastel","hex":"#A18594"},{"code":"4010","name":"Telemagenta","hex":"#CF3476"},{"code":"4011","name":"Violet nacré","hex":"#8673A1"},{"code":"4012","name":"Mûre nacré","hex":"#6C6874"},{"code":"5000","name":"Bleu violet","hex":"#354D73"},{"code":"5001","name":"Bleu vert","hex":"#1F3438"},{"code":"5002","name":"Bleu outremer","hex":"#20214F"},{"code":"5003","name":"Bleu saphir","hex":"#1D1E33"},{"code":"5004","name":"Bleu noir","hex":"#18171C"},{"code":"5005","name":"Bleu de sécurité","hex":"#1E2460"},{"code":"5007","name":"Bleu brillant","hex":"#3E5F8A"},{"code":"5008","name":"Bleu gris","hex":"#26252D"},{"code":"5009","name":"Bleu azur","hex":"#025669"},{"code":"5010","name":"Bleu gentiane","hex":"#0E294B"},{"code":"5011","name":"Bleu acier","hex":"#231A24"},{"code":"5012","name":"Bleu clair","hex":"#3B83BD"},{"code":"5013","name":"Bleu cobalt","hex":"#1E213D"},{"code":"5014","name":"Bleu pigeon","hex":"#606E8C"},{"code":"5015","name":"Bleu ciel","hex":"#2271B3"},{"code":"5017","name":"Bleu signalisation","hex":"#063971"},{"code":"5018","name":"Bleu turquoise","hex":"#3F888F"},{"code":"5019","name":"Bleu capri","hex":"#1B5583"},{"code":"5020","name":"Bleu océan","hex":"#1D334A"},{"code":"5021","name":"Bleu d’eau","hex":"#256D7B"},{"code":"5022","name":"Bleu nocturne","hex":"#252850"},{"code":"5023","name":"Bleu distant","hex":"#49678D"},{"code":"5024","name":"Bleu pastel","hex":"#5D9B9B"},{"code":"5025","name":"Gentiane nacré","hex":"#2A6478"},{"code":"5026","name":"Bleu nuit nacré","hex":"#102C54"},{"code":"6000","name":"Vert patine","hex":"#316650"},{"code":"6001","name":"Vert émeraude","hex":"#287233"},{"code":"6002","name":"Vert feuillage","hex":"#2D572C"},{"code":"6003","name":"Vert olive","hex":"#424632"},{"code":"6004","name":"Vert bleu","hex":"#1F3A3D"},{"code":"6005","name":"Vert mousse","hex":"#2F4538"},{"code":"6006","name":"Olive gris","hex":"#3E3B32"},{"code":"6007","name":"Vert bouteille","hex":"#343B29"},{"code":"6008","name":"Vert brun","hex":"#39352A"},{"code":"6009","name":"Vert sapin","hex":"#31372B"},{"code":"6010","name":"Vert herbe","hex":"#35682D"},{"code":"6011","name":"Vert réséda","hex":"#587246"},{"code":"6012","name":"Vert noir","hex":"#343E40"},{"code":"6013","name":"Vert roseau","hex":"#6C7156"},{"code":"6014","name":"Olive jaune","hex":"#47402E"},{"code":"6015","name":"Olive noir","hex":"#3B3C36"},{"code":"6016","name":"Vert turquoise","hex":"#1E5945"},{"code":"6017","name":"Vert mai","hex":"#4C9141"},{"code":"6018","name":"Vert jaune","hex":"#57A639"},{"code":"6019","name":"Vert blanc","hex":"#BDECB6"},{"code":"6020","name":"Vert oxyde chromique","hex":"#2E3A23"},{"code":"6021","name":"Vert pâle","hex":"#89AC76"},{"code":"6022","name":"Olive brun","hex":"#25221B"},{"code":"6024","name":"Vert signalisation","hex":"#308446"},{"code":"6025","name":"Vert fougère","hex":"#3D642D"},{"code":"6026","name":"Vert opale","hex":"#015D52"},{"code":"6027","name":"Vert clair","hex":"#84C3BE"},{"code":"6028","name":"Vert pin","hex":"#2C5545"},{"code":"6029","name":"Vert menthe","hex":"#20603D"},{"code":"6032","name":"Vert de sécurité","hex":"#317F43"},{"code":"6033","name":"Turquoise menthe","hex":"#497E76"},{"code":"6034","name":"Turquoise pastel","hex":"#7FB5B5"},{"code":"6035","name":"Vert nacré","hex":"#1C542D"},{"code":"6036","name":"Vert opal nacré","hex":"#193737"},{"code":"6037","name":"Vert pur","hex":"#008F39"},{"code":"6038","name":"Vert brillant","hex":"#00BB2D"},{"code":"6039","name":"Vert fibreux","hex":"#B3C43E"},{"code":"7000","name":"Gris petit-gris","hex":"#78858B"},{"code":"7001","name":"Gris argent","hex":"#8A9597"},{"code":"7002","name":"Gris olive","hex":"#7E7B52"},{"code":"7003","name":"Gris mousse","hex":"#6C7059"},{"code":"7004","name":"Gris de sécurité","hex":"#969992"},{"code":"7005","name":"Gris souris","hex":"#646B63"},{"code":"7006","name":"Gris beige","hex":"#6D6552"},{"code":"7008","name":"Gris kaki","hex":"#6A5F31"},{"code":"7009","name":"Gris vert","hex":"#4D5645"},{"code":"7010","name":"Gris tente","hex":"#4C514A"},{"code":"7011","name":"Gris fer","hex":"#434B4D"},{"code":"7012","name":"Gris basalte","hex":"#4E5754"},{"code":"7013","name":"Gris brun","hex":"#464531"},{"code":"7015","name":"Gris ardoise","hex":"#434750"},{"code":"7016","name":"Gris anthracite","hex":"#293133"},{"code":"7021","name":"Gris noir","hex":"#23282B"},{"code":"7022","name":"Gris terre d’ombre","hex":"#332F2C"},{"code":"7023","name":"Gris béton","hex":"#686C5E"},{"code":"7024","name":"Gris graphite","hex":"#474A51"},{"code":"7026","name":"Gris granit","hex":"#2F353B"},{"code":"7030","name":"Gris pierre","hex":"#8B8C7A"},{"code":"7031","name":"Gris bleu","hex":"#474B4E"},{"code":"7032","name":"Gris silex","hex":"#B8B799"},{"code":"7033","name":"Gris ciment","hex":"#7D8471"},{"code":"7034","name":"Gris jaune","hex":"#8F8B66"},{"code":"7035","name":"Gris clair","hex":"#D7D7D7"},{"code":"7036","name":"Gris platine","hex":"#7F7679"},{"code":"7037","name":"Gris poussière","hex":"#7D7F7D"},{"code":"7038","name":"Gris agate","hex":"#B5B8B1"},{"code":"7039","name":"Gris quartz","hex":"#6C6960"},{"code":"7040","name":"Gris fenêtre","hex":"#9DA1AA"},{"code":"7042","name":"Gris signalisation A","hex":"#8D948D"},{"code":"7043","name":"Gris signalisation B","hex":"#4E5452"},{"code":"7044","name":"Gris soie","hex":"#CAC4B0"},{"code":"7045","name":"Telegris 1","hex":"#909090"},{"code":"7046","name":"Telegris 2","hex":"#82898F"},{"code":"7047","name":"Telegris 4","hex":"#D0D0D0"},{"code":"7048","name":"Gris souris nacré","hex":"#898176"},{"code":"8000","name":"Brun vert","hex":"#826C34"},{"code":"8001","name":"Brun terre de Sienne","hex":"#955F20"},{"code":"8002","name":"Brun de sécurité","hex":"#6C3B2A"},{"code":"8003","name":"Brun argile","hex":"#734222"},{"code":"8004","name":"Brun cuivré","hex":"#8E402A"},{"code":"8007","name":"Brun fauve","hex":"#59351F"},{"code":"8008","name":"Brun olive","hex":"#6F4F28"},{"code":"8011","name":"Brun noisette","hex":"#5B3A29"},{"code":"8012","name":"Brun rouge","hex":"#592321"},{"code":"8014","name":"Brun sépia","hex":"#382C1E"},{"code":"8015","name":"Marron","hex":"#633A34"},{"code":"8016","name":"Brun acajou","hex":"#4C2F27"},{"code":"8017","name":"Brun chocolat","hex":"#45322E"},{"code":"8019","name":"Brun gris","hex":"#403A3A"},{"code":"8022","name":"Brun noir","hex":"#212121"},{"code":"8023","name":"Brun orangé","hex":"#A65E2E"},{"code":"8024","name":"Brun beige","hex":"#79553D"},{"code":"8025","name":"Brun pâle","hex":"#755C48"},{"code":"8028","name":"Brun terre","hex":"#4E3B31"},{"code":"8029","name":"Cuivre nacré","hex":"#763C28"},{"code":"9001","name":"Blanc crème","hex":"#FDF4E3"},{"code":"9002","name":"Blanc gris","hex":"#E7EBDA"},{"code":"9003","name":"Blanc de sécurité","hex":"#F4F4F4"},{"code":"9004","name":"Noir de sécurité","hex":"#282828"},{"code":"9005","name":"Noir profond","hex":"#0A0A0A"},{"code":"9006","name":"Aluminium blanc","hex":"#A5A5A5"},{"code":"9007","name":"Aluminium gris","hex":"#8F8F8F"},{"code":"9010","name":"Blanc pur","hex":"#FFFFFF"},{"code":"9011","name":"Noir graphite","hex":"#1C1C1C"},{"code":"9012","name":"Blanc salle blanche","hex":"#F8F2E1"},{"code":"9016","name":"Blanc signalisation","hex":"#F6F6F6"},{"code":"9017","name":"Noir signalisation","hex":"#1E1E1E"},{"code":"9018","name":"Blanc papyrus","hex":"#D7D7D7"},{"code":"9022","name":"Gris clair nacré","hex":"#9C9C9C"},{"code":"9023","name":"Gris foncé nacré","hex":"#828282"}];
  /*__RAL_DATA_END__*/
  // RAL 9005 et 7039 sont réservés à des offres couleur dédiées à tarification propre.
  const EXCLUDED_RAL_CODES = new Set(['9005', '7039']);
  const RESERVED_RAL_MESSAGES = {
    '9005': 'Le RAL 9005 — Noir profond n’est pas proposé dans le choix RAL libre. Lorsqu’une finition Noir / Blackline existe pour ce modèle, sélectionnez-la dans les options de finition.',
    '7039': 'Le RAL 7039 — Gris quartz n’est pas proposé dans le choix RAL libre. Cette teinte est réservée à une offre dédiée.'
  };
  const AVAILABLE_RAL_COLOURS = RAL_COLOURS.filter(({ code }) => !EXCLUDED_RAL_CODES.has(code));
  const FEATURED_CODES = ['7016', '7021', '6009', '6003', '6013', '6021', '9010', '3004', '3002', '5024'];
  const SORTED_RAL_COLOURS = AVAILABLE_RAL_COLOURS.slice().sort((first, second) => first.code.localeCompare(second.code, 'fr', { numeric: true }));
  const RAL_FAMILIES = {
    all: 'Toutes les couleurs',
    1: 'Jaunes',
    2: 'Oranges',
    3: 'Rouges',
    4: 'Violets',
    5: 'Bleus',
    6: 'Verts',
    7: 'Gris',
    8: 'Bruns',
    9: 'Blancs & noirs'
  };

  const normalise = (value = '') => String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('fr')
    .trim();

  const normaliseSearch = (value = '') => normalise(value)
    .replace(/\bral[\s-]*(?=\d)/g, '')
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const isRalChoice = (value) => {
    const text = normalise(value)
      .replace(/thermo[\s-]*laqu/g, 'thermolaqu')
      .replace(/[-–—_]+/g, ' ')
      .replace(/\s+/g, ' ');
    return text.includes('thermolaqu') && text.includes('ral') && text.includes('au choix');
  };

  const reservedColourForQuery = (query) => RAL_COLOURS.find((colour) => {
    if (!EXCLUDED_RAL_CODES.has(colour.code)) return false;
    const hasExactCode = new RegExp(`(?:^|\\D)${colour.code}(?:\\D|$)`).test(query);
    return hasExactCode || query === normaliseSearch(colour.name);
  }) || null;

  if (customElements.get('lsdj-ral-selector')) return;

  customElements.define('lsdj-ral-selector', class LsdjRalSelector extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.productForm = document.getElementById(this.dataset.formId);
      this.scope = this.closest('product-info') || this.closest('.shopify-section') || document;
      this.dialog = this.querySelector('.lsdj-ral-dialog');
      this.dialogTitle = this.querySelector('.lsdj-ral-dialog__header h2');
      this.search = this.querySelector('.lsdj-ral-dialog__search');
      this.featuredGrid = this.querySelector('[data-ral-featured]');
      this.allGrid = this.querySelector('[data-ral-all]');
      this.allSection = this.querySelector('.lsdj-ral-dialog__all');
      this.allTitle = this.querySelector('[data-ral-all-title]');
      this.resultsStatus = this.querySelector('[data-ral-results]');
      this.announcement = this.querySelector('[data-ral-announcement]');
      this.emptyMessage = this.querySelector('.lsdj-ral-dialog__empty');
      this.reservedPanel = this.querySelector('[data-ral-reserved]');
      this.reservedText = this.querySelector('[data-ral-reserved-text]');
      this.reservedAction = this.querySelector('.lsdj-ral-dialog__reserved-action');
      this.familyControls = this.querySelector('[data-ral-families]');
      this.featuredSection = this.querySelector('.lsdj-ral-dialog__featured');
      this.toggleButton = this.querySelector('.lsdj-ral-dialog__toggle');
      this.confirmButton = this.querySelector('.lsdj-ral-dialog__confirm');
      this.copyButton = this.querySelector('.lsdj-ral-selector__copy');
      this.copyStatus = this.querySelector('.lsdj-ral-selector__copy-status');
      this.adviceLink = this.querySelector('.lsdj-ral-selector__advice');
      this.propertyInput = this.querySelector('.lsdj-ral-selector__property');
      this.error = this.querySelector('.lsdj-ral-selector__error');
      this.errorAction = this.querySelector('.lsdj-ral-selector__error-action');
      this.paymentHelp = this.querySelector('.lsdj-ral-selector__payment-help');
      this.selectedColour = null;
      this.confirmedColour = null;
      this.lastConfirmedColour = null;
      this.isActive = false;
      this.showAll = false;
      this.activeFamily = 'all';
      this.selectionIsVisible = true;
      this.returnFocus = null;
      this.blockedPurchaseTrigger = null;
      this.searchTimer = null;
      this.copyStatusTimer = null;
      this.lastResultCount = 0;
      this.paymentWasBlocked = false;
      this.dialogOpenedAt = null;
      this.dialogCloseReason = null;
      this.reservedColour = null;

      this.onChange = this.syncFromOptions.bind(this);
      this.onVariantChanged = this.syncFromOptions.bind(this);
      this.onSubmit = this.guardSubmission.bind(this);
      this.onDocumentClick = this.guardStickyButton.bind(this);
      this.onDialogClick = this.handleDialogClick.bind(this);
      this.onDialogKeydown = this.handleDialogKeydown.bind(this);
      this.onSearch = this.handleSearch.bind(this);
      this.onFamilyClick = this.handleFamilyClick.bind(this);
      this.onClose = this.handleDialogClose.bind(this);

      this.scope.addEventListener('change', this.onChange);
      document.addEventListener('variant:changed', this.onVariantChanged);
      this.productForm?.addEventListener('submit', this.onSubmit, true);
      document.addEventListener('click', this.onDocumentClick, true);
      this.dialog.addEventListener('click', this.onDialogClick);
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('keydown', this.onDialogKeydown);
      this.search.addEventListener('input', this.onSearch);
      this.familyControls.addEventListener('click', this.onFamilyClick);
      this.currentPropertyInput();
      this.querySelector('.lsdj-ral-selector__open').addEventListener('click', (event) => this.openDialog(event.currentTarget));
      this.querySelector('.lsdj-ral-selector__modify').addEventListener('click', (event) => this.openDialog(event.currentTarget));
      this.errorAction.addEventListener('click', (event) => this.openDialog(event.currentTarget));
      this.copyButton.addEventListener('click', () => this.copyConfirmedColour());
      this.adviceLink.addEventListener('click', () => this.track('advice_clicked', { code: this.confirmedColour?.code }));
      this.reservedAction.addEventListener('click', () => this.handleReservedAction());
      this.querySelector('.lsdj-ral-dialog__close').addEventListener('click', () => {
        this.dialogCloseReason = 'close_button';
        this.dialog.close();
      });
      this.toggleButton.addEventListener('click', () => {
        this.showAll = !this.showAll;
        if (!this.showAll) this.activeFamily = 'all';
        this.toggleButton.setAttribute('aria-expanded', String(this.showAll));
        this.toggleButton.textContent = this.showAll ? `Réduire aux ${FEATURED_CODES.length} couleurs recommandées` : `Voir les ${AVAILABLE_RAL_COLOURS.length} couleurs RAL`;
        this.updateFamilyControls();
        this.renderColours();
        this.track(this.showAll ? 'palette_expanded' : 'palette_collapsed');
      });
      this.confirmButton.addEventListener('click', () => this.confirmSelection());

      this.paymentButtonObserver = new MutationObserver(() => {
        if (this.isActive && this.confirmedColour) this.applyConfirmedColour();
        this.updateAcceleratedCheckoutState();
      });
      this.paymentButtonObserver.observe(this.scope === document ? document.body : this.scope, { childList: true, subtree: true });

      this.propertyInputObserver = new MutationObserver(() => {
        if (this.isActive && this.confirmedColour) this.applyConfirmedColour();
      });
      this.propertyInputObserver.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value', 'disabled', 'form']
      });

      this.syncFromOptions();
    }

    disconnectedCallback() {
      if (!this.initialised) return;
      this.scope?.removeEventListener('change', this.onChange);
      document.removeEventListener('variant:changed', this.onVariantChanged);
      this.productForm?.removeEventListener('submit', this.onSubmit, true);
      document.removeEventListener('click', this.onDocumentClick, true);
      this.dialog?.removeEventListener('click', this.onDialogClick);
      this.dialog?.removeEventListener('close', this.onClose);
      this.dialog?.removeEventListener('keydown', this.onDialogKeydown);
      this.search?.removeEventListener('input', this.onSearch);
      this.familyControls?.removeEventListener('click', this.onFamilyClick);
      clearTimeout(this.searchTimer);
      clearTimeout(this.copyStatusTimer);
      this.paymentButtonObserver?.disconnect();
      this.propertyInputObserver?.disconnect();
    }

    variantPicker() {
      return this.previousElementSibling?.matches('variant-selects')
        ? this.previousElementSibling
        : this.scope.querySelector?.('variant-selects');
    }

    selectedOptionValues() {
      const picker = this.variantPicker();
      if (!picker) return [];
      return Array.from(picker.querySelectorAll('select, input[type="radio"]:checked'))
        .flatMap((control) => control.tagName === 'SELECT' ? [control.value] : [control.value]);
    }

    currentPropertyInput() {
      const currentForm = document.getElementById(this.dataset.formId);
      if (currentForm !== this.productForm) {
        this.productForm?.removeEventListener('submit', this.onSubmit, true);
        this.productForm = currentForm;
        this.productForm?.addEventListener('submit', this.onSubmit, true);
      }

      let currentInput = this.querySelector('.lsdj-ral-selector__property');

      if (!currentInput) {
        currentInput = document.createElement('input');
        currentInput.className = 'lsdj-ral-selector__property';
        currentInput.type = 'hidden';
        currentInput.name = 'properties[Couleur RAL]';
        currentInput.disabled = true;
        this.appendChild(currentInput);
      }

      if (currentInput.getAttribute('form') !== this.dataset.formId) {
        currentInput.setAttribute('form', this.dataset.formId);
      }

      this.propertyInput = currentInput;
      return this.propertyInput;
    }

    syncFromOptions() {
      const propertyInput = this.currentPropertyInput();
      const wasActive = this.isActive;
      this.isActive = this.selectedOptionValues().some(isRalChoice);
      this.hidden = !this.isActive;

      if (!this.isActive) {
        propertyInput.disabled = true;
        propertyInput.value = '';
        propertyInput.removeAttribute('value');
        delete propertyInput.dataset.ralCode;
        this.confirmedColour = null;
        this.hideError();
        if (this.dialog.open) {
          this.dialogCloseReason = 'variant_changed';
          this.dialog.close();
        }
      } else if (!wasActive && this.lastConfirmedColour) {
        this.confirmedColour = this.lastConfirmedColour;
        this.applyConfirmedColour();
      } else if (this.confirmedColour) {
        this.applyConfirmedColour();
      }

      this.updateSummary();
      this.updateAcceleratedCheckoutState();
      if (this.isActive && !wasActive) this.track('variant_selected');
    }

    openDialog(trigger) {
      this.returnFocus = trigger;
      this.selectedColour = this.confirmedColour || this.lastConfirmedColour;
      clearTimeout(this.searchTimer);
      this.announcement.textContent = '';
      this.search.value = '';
      this.showAll = Boolean(this.selectedColour && !FEATURED_CODES.includes(this.selectedColour.code));
      this.activeFamily = 'all';
      this.toggleButton.setAttribute('aria-expanded', String(this.showAll));
      this.toggleButton.textContent = this.showAll ? `Réduire aux ${FEATURED_CODES.length} couleurs recommandées` : `Voir les ${AVAILABLE_RAL_COLOURS.length} couleurs RAL`;
      this.updateFamilyControls();
      this.renderColours();
      this.updateDialogSelection();
      this.dialogCloseReason = null;
      this.dialogOpenedAt = performance.now();
      this.dialog.showModal();
      this.updateRovingTabIndexes();
      const source = trigger?.matches('.lsdj-ral-selector__modify')
        ? 'modify'
        : trigger?.matches('.lsdj-ral-selector__error-action') ? 'purchase_blocked' : 'initial';
      this.track('modal_opened', { source });
      requestAnimationFrame(() => {
        const focusTarget = window.matchMedia('(max-width: 767px)').matches ? this.dialogTitle : this.search;
        focusTarget.focus({ preventScroll: true });
      });
    }

    handleDialogClose() {
      clearTimeout(this.searchTimer);
      if (this.dialogOpenedAt !== null) {
        this.track('modal_closed', {
          reason: this.dialogCloseReason || 'unknown',
          has_selection: Boolean(this.selectedColour),
          duration_ms: Math.max(0, Math.round(performance.now() - this.dialogOpenedAt))
        });
      }
      this.dialogOpenedAt = null;
      this.dialogCloseReason = null;
      const focusTarget = this.returnFocus;
      if (focusTarget?.isConnected && !focusTarget.closest('[hidden]') && !focusTarget.matches(':disabled')) {
        focusTarget.focus();
      }
      this.returnFocus = null;
      this.blockedPurchaseTrigger = null;
    }

    handleDialogKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        this.dialogCloseReason = 'escape';
        this.dialog.close();
        return;
      }

      const swatch = event.target.closest?.('.lsdj-ral-swatch');
      if (!swatch || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
      const grid = swatch.closest('.lsdj-ral-dialog__grid');
      const buttons = Array.from(grid.querySelectorAll('.lsdj-ral-swatch'));
      const currentIndex = buttons.indexOf(swatch);
      if (currentIndex < 0 || buttons.length < 2) return;

      const columnCount = Math.max(1, getComputedStyle(grid).gridTemplateColumns.split(' ').length);
      let nextIndex = currentIndex;
      if (event.key === 'ArrowLeft') nextIndex = Math.max(0, currentIndex - 1);
      if (event.key === 'ArrowRight') nextIndex = Math.min(buttons.length - 1, currentIndex + 1);
      if (event.key === 'ArrowUp') nextIndex = Math.max(0, currentIndex - columnCount);
      if (event.key === 'ArrowDown' && currentIndex + columnCount < buttons.length) nextIndex = currentIndex + columnCount;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = buttons.length - 1;
      if (nextIndex === currentIndex) return;

      event.preventDefault();
      buttons.forEach((button, index) => { button.tabIndex = index === nextIndex ? 0 : -1; });
      buttons[nextIndex].focus();
    }

    handleDialogClick(event) {
      if (event.target === this.dialog) {
        this.dialogCloseReason = 'backdrop';
        this.dialog.close();
      }
      const button = event.target.closest('.lsdj-ral-swatch');
      if (!button) return;
      this.selectedColour = AVAILABLE_RAL_COLOURS.find((colour) => colour.code === button.dataset.code) || null;
      this.selectionIsVisible = true;
      this.updatePressedStates();
      this.updateDialogSelection();
      const source = button.closest('[data-ral-featured]')
        ? 'recommended'
        : normaliseSearch(this.search.value) ? 'search' : this.activeFamily === 'all' ? 'full_palette' : 'family';
      this.track('colour_selected', {
        code: this.selectedColour?.code,
        source,
        family: this.activeFamily
      });
    }

    renderColours() {
      const query = normaliseSearch(this.search.value);
      const matches = (colour) => !query || normaliseSearch(`${colour.code} ${colour.name}`).includes(query);
      const searching = query.length > 0;
      const matchesFamily = (colour) => this.activeFamily === 'all' || colour.code.startsWith(this.activeFamily);
      const featured = FEATURED_CODES
        .map((code) => AVAILABLE_RAL_COLOURS.find((colour) => colour.code === code))
        .filter(Boolean)
        .filter((colour) => !searching && matches(colour));
      const all = SORTED_RAL_COLOURS.filter(matches).filter(searching ? () => true : matchesFamily);
      const filteringFamily = !searching && this.activeFamily !== 'all';
      this.reservedColour = searching ? reservedColourForQuery(query) : null;
      this.lastResultCount = all.length;

      this.featuredGrid.replaceChildren(...featured.map((colour) => this.createColourButton(colour, 'recommended')));
      this.featuredSection.hidden = searching || filteringFamily || featured.length === 0;
      this.allSection.hidden = (searching ? all.length === 0 : !this.showAll || all.length === 0);
      this.toggleButton.hidden = searching;
      this.familyControls.hidden = searching;
      this.allTitle.textContent = searching
        ? 'Résultats de recherche'
        : filteringFamily ? `${RAL_FAMILIES[this.activeFamily]} RAL` : 'Toutes les couleurs RAL Classic';
      this.resultsStatus.hidden = Boolean(this.reservedColour) || (searching && all.length === 0) || (!searching && !filteringFamily);
      if (filteringFamily) {
        this.resultsStatus.textContent = `${all.length} ${all.length === 1 ? 'couleur trouvée' : 'couleurs trouvées'}`;
      } else if (!searching) {
        this.resultsStatus.textContent = '';
      }
      if (!this.allSection.hidden) {
        this.allGrid.replaceChildren(...all.map((colour) => this.createColourButton(colour, searching ? 'search' : filteringFamily ? 'family' : 'full_palette')));
      } else {
        this.allGrid.replaceChildren();
      }
      const visibleColours = [
        ...(this.featuredSection.hidden ? [] : featured),
        ...(this.allSection.hidden ? [] : all)
      ];
      this.selectionIsVisible = !this.selectedColour || visibleColours.some((colour) => colour.code === this.selectedColour.code);
      this.reservedPanel.hidden = !this.reservedColour;
      this.reservedText.textContent = this.reservedColour ? RESERVED_RAL_MESSAGES[this.reservedColour.code] : '';
      if (this.reservedColour?.code === '7039') {
        this.reservedAction.textContent = 'Choisir une autre couleur';
      } else if (this.reservedColour?.code === '9005') {
        this.reservedAction.textContent = this.hasDedicatedBlacklineFinish()
          ? 'Voir la finition Noir / Blackline'
          : 'Voir les finitions de ce produit';
      }
      this.emptyMessage.hidden = all.length > 0 || Boolean(this.reservedColour);
      this.updatePressedStates();
      this.updateDialogSelection();
    }

    createColourButton(colour, source) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lsdj-ral-swatch';
      button.dataset.code = colour.code;
      button.dataset.source = source;
      button.tabIndex = -1;
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', `RAL ${colour.code} — ${colour.name}`);
      button.innerHTML = `<span class="lsdj-ral-swatch__colour" style="--lsdj-ral-colour:${colour.hex}" aria-hidden="true"></span><span class="lsdj-ral-swatch__code">RAL ${colour.code}</span><span class="lsdj-ral-swatch__name">${colour.name}</span>`;
      return button;
    }

    updatePressedStates() {
      this.querySelectorAll('.lsdj-ral-swatch').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.code === this.selectedColour?.code));
      });
      this.updateRovingTabIndexes();
    }

    updateRovingTabIndexes() {
      [this.featuredGrid, this.allGrid].forEach((grid) => {
        const buttons = Array.from(grid.querySelectorAll('.lsdj-ral-swatch'));
        if (!buttons.length || grid.closest('section')?.hidden) return;
        const focused = buttons.includes(document.activeElement) ? document.activeElement : null;
        const selected = buttons.find((button) => button.getAttribute('aria-pressed') === 'true');
        const tabbable = focused || selected || buttons[0];
        buttons.forEach((button) => { button.tabIndex = button === tabbable ? 0 : -1; });
      });
    }

    handleSearch() {
      if (normaliseSearch(this.search.value)) {
        this.activeFamily = 'all';
        this.updateFamilyControls();
      }
      this.renderColours();
      clearTimeout(this.searchTimer);
      const queryLength = normaliseSearch(this.search.value).length;
      if (!queryLength) {
        this.announcement.textContent = '';
        return;
      }
      this.resultsStatus.textContent = '';
      this.searchTimer = setTimeout(() => {
        if (this.reservedColour) {
          this.announcement.textContent = RESERVED_RAL_MESSAGES[this.reservedColour.code];
          this.track('reserved_colour_shown', { ral_code: this.reservedColour.code });
          return;
        }
        this.resultsStatus.textContent = `${this.lastResultCount} ${this.lastResultCount === 1 ? 'couleur trouvée' : 'couleurs trouvées'}`;
        this.announcement.textContent = this.lastResultCount
          ? this.resultsStatus.textContent
          : 'Aucune couleur ne correspond à votre recherche.';
        this.track('search', { query_length: queryLength, result_count: this.lastResultCount });
      }, 400);
    }

    handleFamilyClick(event) {
      const button = event.target.closest('[data-ral-family]');
      if (!button || !this.familyControls.contains(button)) return;
      this.activeFamily = button.dataset.ralFamily;
      this.updateFamilyControls();
      this.renderColours();
      this.announcement.textContent = `${this.lastResultCount} ${this.lastResultCount === 1 ? 'couleur trouvée' : 'couleurs trouvées'}`;
      this.track('family_selected', {
        family: this.activeFamily,
        result_count: this.lastResultCount
      });
    }

    updateFamilyControls() {
      this.familyControls.querySelectorAll('[data-ral-family]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.ralFamily === this.activeFamily));
      });
    }

    updateDialogSelection() {
      const swatch = this.querySelector('.lsdj-ral-dialog__selection-swatch');
      const text = this.querySelector('.lsdj-ral-dialog__selection-text');
      if (!this.selectedColour) {
        swatch.hidden = true;
        text.textContent = 'Aucune couleur sélectionnée';
        this.confirmButton.disabled = true;
        this.confirmButton.textContent = 'Sélectionnez une couleur';
        this.confirmButton.removeAttribute('aria-label');
        return;
      }
      swatch.hidden = false;
      swatch.style.background = this.selectedColour.hex;
      if (!this.selectionIsVisible) {
        text.textContent = `Sélection actuelle hors filtre : ${this.formatColour(this.selectedColour)}`;
        this.confirmButton.disabled = true;
        this.confirmButton.textContent = 'Choisissez une couleur affichée';
        this.confirmButton.removeAttribute('aria-label');
        return;
      }
      text.textContent = this.formatColour(this.selectedColour);
      this.confirmButton.disabled = false;
      this.confirmButton.textContent = `Valider RAL ${this.selectedColour.code}`;
      this.confirmButton.removeAttribute('aria-label');
    }

    hasDedicatedBlacklineFinish() {
      const picker = this.variantPicker();
      if (!picker) return false;
      return Array.from(picker.querySelectorAll('select option, input[type="radio"]')).some((control) => {
        const value = normalise(control.value || control.textContent);
        return value.includes('blackline') || (value.includes('9005') && !isRalChoice(value));
      });
    }

    handleReservedAction() {
      const code = this.reservedColour?.code;
      if (!code) return;
      if (code === '7039') {
        this.search.value = '';
        this.renderColours();
        this.announcement.textContent = 'Recherche effacée. Choisissez une autre couleur RAL.';
        this.search.focus();
        this.track('reserved_colour_action', { ral_code: code, action: 'clear_search' });
        return;
      }
      this.returnToVariantPicker(code);
    }

    returnToVariantPicker(code) {
      const picker = this.variantPicker();
      if (!picker) return;
      const selectedControls = Array.from(picker.querySelectorAll('select, input[type="radio"]:checked'));
      const focusTarget = selectedControls.find((control) => isRalChoice(control.value))
        || picker.querySelector('select, input[type="radio"], button, [tabindex]:not([tabindex="-1"])');
      const scrollTarget = focusTarget?.closest('fieldset') || focusTarget || picker;
      this.returnFocus = focusTarget || this.returnFocus;
      this.dialogCloseReason = 'reserved_offer';
      this.dialog.close();
      requestAnimationFrame(() => {
        const behaviour = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        scrollTarget.scrollIntoView({ behavior: behaviour, block: 'center' });
      });
      this.track('reserved_colour_action', { ral_code: code, action: 'view_finishes' });
    }

    confirmSelection() {
      const availableColour = AVAILABLE_RAL_COLOURS.find((colour) => colour.code === this.selectedColour?.code);
      if (!availableColour) return;
      this.confirmedColour = availableColour;
      this.lastConfirmedColour = availableColour;
      this.track('colour_confirmed', { code: this.confirmedColour.code });
      this.applyConfirmedColour();
      this.updateSummary();
      this.hideError();
      this.updateAcceleratedCheckoutState();
      this.returnFocus = this.blockedPurchaseTrigger || this.querySelector('.lsdj-ral-selector__modify');
      this.dialogCloseReason = 'confirmed';
      this.dialog.close();
    }

    applyConfirmedColour() {
      if (!this.isActive || !this.confirmedColour) return;
      const propertyInput = this.currentPropertyInput();
      if (!propertyInput) return;
      const value = this.formatColour(this.confirmedColour);
      if (propertyInput.value !== value) propertyInput.value = value;
      if (propertyInput.getAttribute('value') !== value) propertyInput.setAttribute('value', value);
      propertyInput.dataset.ralCode = this.confirmedColour.code;
      if (propertyInput.disabled) propertyInput.disabled = false;
    }

    updateSummary() {
      const prompt = this.querySelector('.lsdj-ral-selector__prompt');
      const summary = this.querySelector('.lsdj-ral-selector__summary');
      const hasConfirmed = this.isActive && Boolean(this.confirmedColour);
      prompt.hidden = hasConfirmed;
      summary.hidden = !hasConfirmed;
      this.copyStatus.textContent = '';
      if (!hasConfirmed) return;
      this.querySelector('.lsdj-ral-selector__summary-swatch').style.background = this.confirmedColour.hex;
      this.querySelector('.lsdj-ral-selector__summary-text').textContent = this.formatColour(this.confirmedColour);
    }

    async copyConfirmedColour() {
      if (!this.confirmedColour) return;
      const value = `RAL ${this.confirmedColour.code}`;
      let copied = false;

      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard API unavailable');
        await navigator.clipboard.writeText(value);
        copied = true;
      } catch (_error) {
        const fallback = document.createElement('textarea');
        fallback.value = value;
        fallback.readOnly = true;
        fallback.style.position = 'fixed';
        fallback.style.left = '-9999px';
        document.body.appendChild(fallback);
        fallback.select();
        try {
          copied = document.execCommand('copy');
        } finally {
          fallback.remove();
        }
      }

      clearTimeout(this.copyStatusTimer);
      this.copyStatus.textContent = copied ? 'Code RAL copié.' : 'La copie a échoué. Sélectionnez le code ci-dessus pour le copier.';
      this.copyStatusTimer = setTimeout(() => { this.copyStatus.textContent = ''; }, 4000);
      if (copied) this.track('code_copied', { code: this.confirmedColour.code });
    }

    updateAcceleratedCheckoutState() {
      const paymentButton = this.scope.querySelector?.('.shopify-payment-button');
      const shouldBlock = this.isActive && !this.confirmedColour;
      const paymentIsBlocked = Boolean(paymentButton && shouldBlock);
      this.paymentHelp.hidden = !paymentButton || !shouldBlock;
      if (paymentButton) {
        paymentButton.toggleAttribute('inert', shouldBlock);
        paymentButton.setAttribute('aria-disabled', String(shouldBlock));
        paymentButton.classList.toggle('lsdj-ral-payment-blocked', shouldBlock);
      }
      if (paymentIsBlocked && !this.paymentWasBlocked) this.track('payment_express_disabled_shown');
      this.paymentWasBlocked = paymentIsBlocked;
    }

    guardSubmission(event) {
      if (!this.isActive) return;
      if (this.confirmedColour) {
        this.applyConfirmedColour();
        this.track('add_attempt_allowed', { code: this.confirmedColour.code });
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showError(event.submitter);
    }

    guardStickyButton(event) {
      if (!this.isActive) return;
      const button = event.target.closest?.('[name="add"], .shopify-payment-button');
      if (!button) return;
      const ownsMainButton = button.form?.getAttribute('id') === this.dataset.formId;
      const ownsStickyButton = button.closest('.sticky-atc-bar') && document.querySelectorAll('lsdj-ral-selector:not([hidden])').length === 1;
      const ownsPaymentButton = this.scope.contains(button);
      if (!ownsMainButton && !ownsStickyButton && !ownsPaymentButton) return;
      if (this.confirmedColour) {
        this.applyConfirmedColour();
        if (button.closest('.shopify-payment-button')) {
          this.track('payment_express_clicked', { code: this.confirmedColour.code });
        }
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showError(button);
    }

    showError(trigger) {
      this.blockedPurchaseTrigger = trigger instanceof HTMLElement ? trigger : null;
      this.track('add_blocked', {
        source: trigger?.closest?.('.shopify-payment-button') ? 'payment_express' : trigger?.closest?.('.sticky-atc-bar') ? 'sticky_add' : 'main_add'
      });
      this.error.hidden = false;
      this.error.focus({ preventScroll: true });
      const behaviour = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.error.scrollIntoView({ behavior: behaviour, block: 'center' });
    }

    hideError() {
      this.error.hidden = true;
    }

    formatColour(colour) {
      return `RAL ${colour.code} — ${colour.name}`;
    }

    track(action, detail = {}) {
      const payload = {
        event: `lsdj_ral_${action}`,
        component: 'ral_selector',
        product_id: this.dataset.productId || undefined,
        product_handle: this.dataset.productHandle || undefined,
        variant_id: this.productForm?.querySelector('[name="id"]')?.value || undefined,
        section_id: this.dataset.sectionId || undefined,
        ...detail
      };
      Object.keys(payload).forEach((key) => payload[key] === undefined && delete payload[key]);
      this.dispatchEvent(new CustomEvent('lsdj:ral', { bubbles: true, detail: { ...payload } }));
      window.dataLayer = window.dataLayer || [];
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ ...payload });
    }
  });
})();
